import { render } from "./AdminPerformanceChart.vue?vue&type=template&id=42d154e6"
import script from "./AdminPerformanceChart.vue?vue&type=script&lang=js"
export * from "./AdminPerformanceChart.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/laravel/sundae-scoops/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__